import {
  Container,
  Box,
  Card,
  TextField,
  FormControl,
  FormHelperText,
  CardContent,
  Typography,
  FormControlLabel,
  Checkbox,
  Snackbar,
  Alert,
} from "@mui/material";
import React, { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import emailjs from "@emailjs/browser";


const Careers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const onDrop = useCallback((acceptedFiles) => {
    setFormData((prev) => ({ ...prev, acceptedFiles: acceptedFiles }));
  }, []);

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    noClick: true, // Prevents auto-opening of file dialog on click
    noKeyboard: true, // Prevents space/enter triggering file dialog
  });

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    industry: "",
    interestedIn: "",
    jobTitle: "",
    roleDes: "",
    acceptedFiles: null,
  });
  const [isChecked, setIsChecked] = useState(false);
  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const showToast = (message, severity) => {
    setToast({ open: true, message, severity });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email format.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleSubmit = () => {
  //   if (!isChecked) {
  //     showToast("Please check the box to proceed.", "warning");
  //     return;
  //   }

  //   if (!validateForm()) {
  //     showToast("Please fill in all required fields correctly.", "error");
  //     return;
  //   }
  //   console.log(formData);
  //   showToast("Form submitted successfully!", "success");
  //   setFormData({
  //     name: "",
  //     phone: "",
  //     email: "",
  //     industry: "",
  //     interestedIn: "",
  //     jobTitle: "",
  //     roleDes: "",
  //     acceptedFiles: null,
  //   });
  
  //   setIsChecked(false);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
  
    if (!isChecked) {
      showToast("Please check the box to proceed.", "warning");
      return;
    }
  
    if (!validateForm()) {
      showToast("Please fill in all required fields correctly.", "error");
      return;
    }
  
    // Convert file to Base64
    const file = formData.acceptedFiles;
    let fileBase64 = "";
  
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      
      reader.onload = async () => {
        fileBase64 = reader.result.split(",")[1]; // Get Base64 content without metadata
  
        // EmailJS template parameters
        const templateParams = {
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          industry: formData.industry,
          interestedIn: formData.interestedIn,
          jobTitle: formData.jobTitle,
          roleDes: formData.roleDes,
          resume: fileBase64, // Attach file
        };
  
        try {
          const result = await emailjs.send(
            "service_m4ptwls", // Replace with your service ID
            "template_akzft5d", // Replace with your template ID
            templateParams,
            "SLqBYvM3sQOsswwCz" // Replace with your EmailJS public key
          );
  
          console.log("Email sent successfully:", result.text);
          showToast("Email sent successfully!", "success");
        } catch (error) {
          console.error("Failed to send email:", error);
          showToast("Failed to send email. Please try again later.", "error");
        }
      };
    } else {
      showToast("Please upload a resume.", "error");
      return;
    }
  
    // Reset form after submission
    setFormData({
      name: "",
      phone: "",
      email: "",
      industry: "",
      interestedIn: "",
      jobTitle: "",
      roleDes: "",
      acceptedFiles: null,
    });
  
    setIsChecked(false);
  };

  const handleCloseToast = () => {
    setToast({ ...toast, open: false });
  };

  return (
    <Container
      sx={{
        margin: "0 !important",
        padding: "0 !important",
        maxWidth: "100% !important",
        backgroundColor: "#FFEEF9",
      }}
    >
      <div className="clientForm">
        <div className="clientForm__title">Looking for new Opportunities</div>
        <div
          className="clientForm__mainFrame"
          style={{ height: "auto", paddingBottom: "5%" }}
        >
          <Container
            sx={{
              padding: "5% 0 0 0",
              margin: "1",
              maxWidth: "90% !important",
            }}
          >
            <Box
              className="inputAndInfoBox"
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                height: "auto",
                padding: "0 0 0 1%",
                gap: "50px",
              }}
            >
              <Card
                sx={{
                  backgroundColor: "#000",
                  borderRadius: "10px",
                  width: { xs: "100%", md: "50%" },
                }}
              >
                <CardContent sx={{ margin: "5%" }}>
                  {/* Name Field */}
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                        "& .MuiInputBase-input": {
                          padding: "10px", // Removes internal padding
                        },
                      }}
                      onChange={handleInputChange}
                      name="name"
                      value={formData.name}
                    />
                    <FormHelperText
                      sx={{
                        color: "#fff",
                        fontSize: "0.9rem",
                        marginTop: "5px",
                      }}
                    >
                      Name
                    </FormHelperText>
                  </FormControl>
                  {/* Phone & Email */}
                  <Box sx={{ display: "flex", gap: "1rem", marginTop: "5%" }}>
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                          "& .MuiInputBase-input": {
                            padding: "10px", // Removes internal padding
                          },
                        }}
                        onChange={handleInputChange}
                        name="phone"
                        value={formData.phone}
                      />
                      <FormHelperText
                        sx={{
                          color: "#fff",
                          fontSize: "0.9rem",
                          marginTop: "5px",
                        }}
                      >
                        Phone
                      </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        variant="outlined"
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                          "& .MuiInputBase-input": {
                            padding: "10px", // Removes internal padding
                          },
                        }}
                        onChange={handleInputChange}
                        name="email"
                        value={formData.email}
                      />
                      <FormHelperText
                        sx={{
                          color: "#fff",
                          fontSize: "0.9rem",
                          marginTop: "5px",
                        }}
                      >
                        Email
                      </FormHelperText>
                    </FormControl>
                  </Box>
                  {/* Industry & Interested in */}
                  <Box sx={{ display: "flex", gap: "1rem", marginTop: "5%" }}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        variant="outlined"
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                          "& .MuiInputBase-input": {
                            padding: "10px", // Removes internal padding
                          },
                        }}
                        onChange={handleInputChange}
                        name="industry"
                        value={formData.industry}
                      ></TextField>
                      <FormHelperText
                        sx={{
                          color: "#fff",
                          fontSize: "0.9rem",
                          marginTop: "5px",
                        }}
                      >
                        Industry
                      </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        variant="outlined"
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                          "& .MuiInputBase-input": {
                            padding: "10px", // Removes internal padding
                          },
                        }}
                        onChange={handleInputChange}
                        name="interestedIn"
                        value={formData.interestedIn}
                      ></TextField>
                      <FormHelperText
                        sx={{
                          color: "#fff",
                          fontSize: "0.9rem",
                          marginTop: "5px",
                        }}
                      >
                        Interested in
                      </FormHelperText>
                    </FormControl>
                  </Box>
                  {/* Job Title */}
                  <FormControl fullWidth sx={{ marginTop: "5%" }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                        "& .MuiInputBase-input": {
                          padding: "10px", // Removes internal padding
                        },
                      }}
                      onChange={handleInputChange}
                      name="jobTitle"
                      value={formData.jobTitle}
                    />
                    <FormHelperText
                      sx={{
                        color: "#fff",
                        fontSize: "0.9rem",
                        marginTop: "5px",
                      }}
                    >
                      Job Title
                    </FormHelperText>
                  </FormControl>
                  {/* Role Description */}
                  <FormControl fullWidth sx={{ marginTop: "5%" }}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      variant="outlined"
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                        "& .MuiInputBase-input": {
                          padding: "10px", // Removes internal padding
                        },
                      }}
                      onChange={handleInputChange}
                      name="roleDes"
                      value={formData.roleDes}
                    />
                    <FormHelperText
                      sx={{
                        color: "#fff",
                        fontSize: "0.9rem",
                        marginTop: "5px",
                      }}
                    >
                      Describe your Role
                    </FormHelperText>
                  </FormControl>
                </CardContent>
              </Card>
              <Card
                sx={{
                  background: "transparent",
                  boxShadow: "none",
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: "100%",
                  width: { xs: "100%", md: "50%" },
                }}
              >
                <Typography sx={{ fontFamily: "Inter", fontSize: "20px" }}>
                  Upload Cover Letter
                </Typography>
                <Box
                  {...getRootProps()}
                  sx={{
                    boxSizing: "border-box",
                    height: "245px",
                    background: "rgba(255, 255, 255, 0.68)",
                    border: "2px dashed #F005A2",
                    borderRadius: "33px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "5%",
                    flexDirection: "column",
                    cursor: "pointer",
                  }}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <input {...getInputProps()} />
                  <img
                    src="/assets/upload.png"
                    alt="upload"
                    style={{ width: "10%" }}
                  ></img>
                  <Typography variant="body1">
                    Drag & drop files or{" "}
                    <span
                      onClick={open}
                      style={{
                        textDecoration: "underline",
                        color: "#F005A2",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      Browse
                    </span>
                  </Typography>
                  {formData?.acceptedFiles?.length > 0 && (
                    <Box sx={{ marginTop: "10px", textAlign: "center" }}>
                      <Typography variant="h6" sx={{fontSize:{xs:'12px', md:'14px'}}}>Uploaded Files:</Typography>
                      {formData.acceptedFiles.map((file, index) => (
                        <Typography key={index} sx={{ fontWeight: "bold" }}>{file.name}</Typography>
                      ))}
                    </Box>
                  )}
                  <Typography
                    sx={{
                      fontFamily: "Montserrat",
                      color: "#676767",
                      textAlign: "center",
                    }}
                  >
                    Supported formates: JPEG, PNG, GIF, MP4, PDF, PSD, AI, Word,
                    PPT
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Montserrat",
                      color: "#FF0000",
                      textAlign: "center",
                    }}
                  >
                    Max file size: 500KB
                  </Typography>
                </Box>
              </Card>
            </Box>
          </Container>

          <Container
            sx={{
              padding: "3% 0 0 10% !important",
              margin: "0",
              maxWidth: "100% !important",
              "@media (max-width: 600px)": {
                padding: "5% 5% 0 5% !important", // Adjust padding for smaller screens
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                padding: "0",
                margin: "0",
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{
                      "& .MuiSvgIcon-root": {
                        color: "#F005A2",
                        fontSize: "30px",
                        "@media (max-width: 600px)": {
                          fontSize: "24px", // Smaller checkbox for mobile
                        },
                      },
                      "& .Mui-checked": {
                        color: "#F005A2",
                      },
                      paddingRight: "4%",
                    }}
                    required
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    component="span"
                    fontFamily={"'Inter', sans-serif"}
                    fontSize={16}
                    sx={{
                      fontSize: "16px",
                      "@media (max-width: 600px)": {
                        fontSize: "14px", // Smaller font size on mobile
                      },
                    }}
                  >
                    <strong>Tecloq</strong> is committed to protecting and
                    respecting your privacy,
                    <br />
                    By clicking submit below, you consent to allow{" "}
                    <strong>Tecloq</strong> to process the personal information
                    submitted above to provide you the content requested.
                    <br />
                    Please review our Privacy Policy.
                  </Typography>
                }
              />
            </Box>
          </Container>
          <Container
            sx={{
              padding: "4% 0 0 85% !important",
              margin: "0",
              maxWidth: "100% !important",
              "@media (max-width: 600px)": {
                padding: "5% 0 0 0 !important", // Center align on mobile
                display: "flex",
                justifyContent: "center",
              },
            }}
          >
            <div
              className="submitBtn"
              style={{
                display: "flex",
                width: "150.84px",
                height: "52.23px",
                backgroundColor: isChecked ? "#F005A2" : "#FF5BC7",
                borderRadius: "45.25px",
                opacity: "100%",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 2% 0 2%",
                cursor: isChecked ? "pointer" : "not-allowed",
              }}
              onClick={isChecked ? handleSubmit : null}
            >
              <div
                className="submitBtn__Text"
                style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontSize: "21px",
                  letterSpacing: "8%",
                  fontWeight: "700",
                  "@media (max-width: 600px)": {
                    fontSize: "18px", // Smaller text size on mobile
                  },
                }}
              >
                Submit
              </div>
              <div
                className="submitBtn__Arrow"
                style={{
                  width: "32.84px",
                  height: "32.23px",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "45.25px",
                  opacity: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "7%",
                  "@media (max-width: 600px)": {
                    width: "28px", // Smaller arrow size on mobile
                    height: "28px",
                    marginLeft: "5%",
                  },
                }}
              >
                <ArrowForwardIcon></ArrowForwardIcon>
              </div>
            </div>
          </Container>
          <Snackbar
            open={toast.open}
            autoHideDuration={3000} // 3 seconds
            onClose={handleCloseToast}
            anchorOrigin={{ vertical: "top", horizontal: "right" }} // Top-right position
          >
            <Alert
              onClose={handleCloseToast}
              severity={toast.severity}
              sx={{ width: "100%" }}
            >
              {toast.message}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </Container>
  );
};
export default Careers;
